<template>
  <div class="pinwall__edit" ref="editPost" :style="setScroll">
    <b-button
      class="close-button action-button"
      type="is-danger"
      rounded
      icon-left="close"
      @click="$emit('close')"
      >{{ $t("close") }}</b-button
    >
    <section>
      <form @submit.prevent="validateBeforeSubmit">
        <b-field
          :label="`${$t('name.name')} (${selectedPinwall.name.length}/30)`"
          :type="{ 'is-danger': errors.has('name') }"
          :message="errors.first('name')"
        >
          <b-input
            v-model="selectedPinwall.name"
            name="name"
            v-validate="'required|max:30'"
          />
        </b-field>

        <b-field
          :label="
            `${$t('description.name')} (${selectedPinwall.desc.length}/40)`
          "
          :type="{ 'is-danger': errors.has('desc') }"
          :message="errors.first('desc')"
        >
          <b-input
            v-model="selectedPinwall.desc"
            name="desc"
            v-validate="'max:40'"
          />
        </b-field>

        <b-field :label="$t('space.selectedSpace')">
          <span class="space">{{
            selectedPinwall.space === "all"
              ? $t("space.all").capitalize()
              : selectedPinwall.space.capitalize()
          }}</span>
        </b-field>

        <b-collapse
          class="card"
          animation="slide"
          :open="false"
          aria-id="contentIdForA11y3"
        >
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="contentIdForA11y3"
            >
              <p class="card-header-title">
                {{ $t("options.name") }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
              </a>
            </div>
          </template>

          <div class="content">
            <b-switch
              v-model="selectedPinwall.options.comments"
              name="comment"
              >{{ $t("comments.name") }}</b-switch
            >
            <b-switch
              v-if="user"
              v-model="selectedPinwall.options.collaboration"
              name="collab"
              :title="$t('collab.pinwallTitle')"
              >{{ $t("collab.name") }}</b-switch
            >
            <div class="second-options">
              <b-switch v-model="selectedPinwall.options.chat" name="chat"
                >Chat</b-switch
              >
              <b-switch
                v-model="selectedPinwall.options.videoChat"
                name="videoChat"
                >Video chat</b-switch
              >
            </div>
            <div class="second-options">
              <b-switch
                v-if="user"
                v-model="selectedPinwall.options.approval"
                :title="$t('approval.pinwallTitle')"
                name="approval"
                >{{ $t("approval.name") }}</b-switch
              >
              <b-switch
                v-model="selectedPinwall.options.private"
                name="private"
              >
                {{ $t("private.name") }}</b-switch
              >
            </div>
            <b-field
              style="margin-bottom: 20px;margin-top: 20px"
              v-if="selectedPinwall.options.private"
              label="Password"
              :type="{ 'is-danger': errors.has('password') }"
              :message="errors.first('password')"
            >
              <b-input
                type="password"
                placeholder="New password"
                v-model="password"
                name="password"
                password-reveal
              />
            </b-field>
          </div>
        </b-collapse>

        <button
          type="submit"
          class="button is-success is-rounded action-button"
        >
          {{ $t("save.name") }}
        </button>
      </form>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { setScroll } from "../../mixins/setScroll.js";
import { generateValidUrlString } from "../../utils/helpers";

export default {
  data() {
    return {
      selectedPinwall: {},
      password: "",
      clientHeight: 0
    };
  },
  props: {
    pinwall: {
      type: Object
    }
  },
  mixins: [setScroll],
  created() {
    this.selectedPinwall = this.pinwall;
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["savePinwall"]),
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.toast.open({
            message: this.$t("form.isValid"),
            type: "is-success",
            position: "is-top-right"
          });

          this.selectedPinwall.password =
            this.password !== ""
              ? this.password
              : this.selectedPinwall.password;
          this.selectedPinwall.pinwallId = generateValidUrlString(
            this.selectedPinwall.name
          );
          this.savePinwall(this.selectedPinwall).then(() => {
            this.$emit("updated");
          });
          return;
        }
        this.$buefy.toast.open({
          message: this.$t("form.notValid"),
          type: "is-danger",
          position: "is-top-right"
        });
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.clientHeight = this.$refs.editPost.clientHeight;
    });
  }
};
</script>
